import React from 'react';
import { Card } from '@kajabi/sage-react';
import PromptSuggestions from 'common/components/CopyMagic/generators/ConversationAssistant/components/PromptSuggestions';

type Props = {
  last: boolean;
};

const GreetingReturn = ({ last }: Props) => (
  <>
    <Card
      className="copy-magic-conversation-assistant-message copy-magic-conversation-assistant-message--greeting-return"
      compact
      data-testid="message-greeting-return-1"
    >
      <span role="img" aria-label="wave">
        👋
      </span>
      &nbsp;Hey there, I&apos;m Ama
    </Card>
    <Card
      className="copy-magic-conversation-assistant-message copy-magic-conversation-assistant-message--greeting-return"
      compact
      data-testid="message-greeting-return-2"
    >
      What can I help you with?
    </Card>
    {last && <PromptSuggestions />}
  </>
);

export default GreetingReturn;
